export const POLYGON_COLORS = [
  '#9b5de5',
  '#264653',
  '#d90429',
  '#fee440',
  '#f15bb5',
  '#bc4749',
  '#80e47c',
  '#3c096c',
  '#0496ff',
  '#eb5e28',
  '#718355',
  '#f1c0e8',
  '#8e7dbe',
  '#661d44',
  '#5d5f76',
  '#23c881',
  '#63e448',
  '#3371fb',
  '#21a5c8',
  '#aa80fd',
  '#87ca80',
  '#4167cf'
];
